const throttle = (fn, delay = 100) => {
    let throttled = false;
    const throttledFn = (...args) => {
        if (throttled) {
            return;
        }
        fn(...args);
        throttled = true;
        setTimeout(() => {
            throttled = false;
        }, delay);
    };
    return throttledFn;
};
export default throttle;
//# sourceMappingURL=index.js.map